import { createRouter, createWebHistory } from 'vue-router'
import Layout from '../components/Layout.vue'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import ActivityManagement from '../views/ActivityManagement.vue'
import UserManagement from '../views/UserManagement.vue'
import TeamManagement from '../views/TeamManagement.vue'
import OrderManagement from '../views/OrderManagement.vue'
import SystemSettings from '../views/SystemSettings.vue'
import SensitiveWordManagement from '../views/SensitiveWordManagementNew.vue'  // 使用新的敏感词管理页面
import FeedbackManagement from '../views/FeedbackManagement.vue'
import DocumentManagement from '../views/DocumentManagement.vue'
import PaymentSettings from '../views/PaymentSettings.vue'
import MembershipManagement from '../views/MembershipManagement.vue'
import UserProfile from '../views/UserProfile.vue'
import OrderDetail from '../views/OrderDetail.vue'
// 导入人工审核页面
import ManualReview from '../views/ManualReview.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: { 
          title: '数据概览', 
          icon: 'DataBoard',
          requiresAuth: true 
        }
      },
      {
        path: 'activities',
        name: 'ActivityManagement',
        component: ActivityManagement,
        meta: { 
          title: '活动管理', 
          icon: 'Calendar',
          requiresAuth: true 
        }
      },
      {
        path: 'users',
        name: 'UserManagement',
        component: UserManagement,
        meta: { 
          title: '用户管理', 
          icon: 'User',
          requiresAuth: true 
        }
      },
      {
        path: 'teams',
        name: 'TeamManagement',
        component: TeamManagement,
        meta: { 
          title: '战队管理', 
          icon: 'Trophy',
          requiresAuth: true 
        }
      },
      {
        path: 'orders',
        name: 'OrderManagement',
        component: OrderManagement,
        meta: { 
          title: '订单管理', 
          icon: 'ShoppingCart',
          requiresAuth: true 
        }
      },
      {
        path: 'orders/:id',
        name: 'OrderDetail',
        component: OrderDetail,
        meta: {
          title: '订单详情',
          requiresAuth: true,
          hideInMenu: true  // 不在侧边栏显示
        }
      },
      {
        path: 'settings',
        name: 'SystemSettings',
        component: SystemSettings,
        meta: {
          title: '系统设置',
          icon: 'Setting',
          requiresAuth: true
        }
      },
      {
        path: 'sensitive-words',
        name: 'SensitiveWordManagement',
        component: SensitiveWordManagement,
        meta: {
          title: '敏感词管理',
          icon: 'Filter',
          requiresAuth: true
        }
      },
      {
        path: 'feedbacks',
        name: 'FeedbackManagement',
        component: FeedbackManagement,
        meta: {
          title: '意见反馈',
          icon: 'ChatLineSquare',
          requiresAuth: true
        }
      },
      {
        path: 'documents',
        name: 'DocumentManagement',
        component: DocumentManagement,
        meta: {
          title: '文档管理',
          icon: 'Document',
          requiresAuth: true
        }
      },
      {
        path: '/payment-config',
        name: 'PaymentConfig',
        component: () => import('@/views/PaymentConfig.vue'),
        meta: { title: '支付配置', icon: 'payment' }
      },
      {
        path: '/refund-management',
        name: 'RefundManagement',
        component: () => import('@/views/RefundManagement.vue'),
        meta: { title: '退款管理', icon: 'refund' }
      },
      {
        path: 'payment-settings',
        name: 'PaymentSettings',
        component: PaymentSettings,
        meta: {
          title: '支付配置',
          icon: 'CreditCard',
          requiresAuth: true
        }
      },
      {
        path: 'membership',
        name: 'MembershipManagement',
        component: MembershipManagement,
        meta: {
          title: '会员权益管理',
          icon: 'Medal',
          requiresAuth: true
        }
      },
      {
        path: 'profile',
        name: 'UserProfile',
        component: UserProfile,
        meta: {
          title: '个人中心',
          icon: 'User',
          requiresAuth: true,
          hideInMenu: true  // 不在侧边栏显示
        }
      },
      {
        path: 'manual-review',
        name: 'ManualReview',
        component: ManualReview,
        meta: {
          title: '人工审核',
          icon: 'Warning',
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/dashboard'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫 - 认证检查
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('admin_token')
  
  if (to.meta.requiresAuth && !token) {
    next('/login')
  } else if (to.path === '/login' && token) {
    next('/dashboard')
  } else {
    next()
  }
})

export default router